import { GetFunc } from "./types"

export const getSize = (percentDiff: number) => (value: number) => value / percentDiff

export const getDesktopOptions = (
  getWidth: GetFunc,
  getHeight: GetFunc
) => ({
  map: {
    from: {
      top: getHeight(-300),
      left: getWidth(-20)
    },
    to: [
      {
        top: getHeight(-300),
        left: getWidth(-84),
        config: {
          duration: 1500,
        }
      },
      {
        top: getHeight(-205),
        left: getWidth(-84),
        config: {
          duration: 2000,
        }
      },
      {
        top: getHeight(-205),
        left: getWidth(-42),
        config: {
          duration: 1000,
        }
      },
      {
        top: getHeight(-223),
        left: getWidth(-2),
        config: {
          duration: 1000,
        }
      },
      {
        top: getHeight(-300),
        left: getWidth(-2),
        config: {
          duration: 1700,
        }
      },
      {
        top: getHeight(-300),
        left: getWidth(-20),
        config: {
          duration: 500,
        }
      }
    ],
    loop: {
      reverse: true
    }
  },
  car: {
    lightingColor: "#47B4E3",
    label: "2022 Tesla",
    color: "#8D99FF",
    wrapper: {
      from: {
        top: getHeight(555),
        left: getWidth(241)
      },
      to: [
        {
          top: getHeight(555),
          left: getWidth(305),
          config: {
            duration: 1500
          }
        },
        {
          top: getHeight(460),
          left: getWidth(305),
          config: {
            duration: 2000
          }
        },
        {
          top: getHeight(460),
          left: getWidth(263),
          config: {
            duration: 1000
          }
        },
        {
          top: getHeight(478),
          left: getWidth(223),
          config: {
            duration: 1000
          }
        },
        {
          top: getHeight(555),
          left: getWidth(223),
          config: {
            duration: 1700
          }
        },
        {
          top: getHeight(555),
          left: getWidth(241),
          config: {
            duration: 500,
          }
        }
      ],
      loop: {
        reverse: true
      }
    },
    icon: {
      from: {
        transform: "rotate(90deg)"
      },
      to: [
        {
          transform: "rotate(0deg)",
          delay: 1400,
          config: {
            duration: 200
          }
        },
        {
          transform: "rotate(-90deg)",
          delay: 1800,
          config: {
            duration: 200
          }
        },
        {
          transform: "rotate(-135deg)",
          delay: 850,
          config: {
            duration: 100
          }
        },
        {
          transform: "rotate(-180deg)",
          delay: 900,
          config: {
            duration: 100
          }
        },
        {
          transform: "rotate(-270deg)",
          delay: 1550,
          config: {
            duration: 200
          }
        },
      ],
      loop: {
        from: {
          transform: "rotate(90deg)"
        },
        delay: 400
      }
    }
  }
})